export default "__VITE_ASSET__CoqSyUSt__"